import React, { FC } from 'react';
import { useTranslations, TranslationKey } from '@lang';
import { SubTitleStyled } from './SubTitle.styles';

type SubTitleProps = {
  titleId: TranslationKey;
  values: {};
};

export const SubTitle: FC<SubTitleProps> = ({ titleId, values }) => {
  const { t } = useTranslations();
  return <SubTitleStyled>{t(titleId, values)}</SubTitleStyled>;
};
